module.exports = __webpack_public_path__ + "static/media/icon-filter.5ce660e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Schools/assets/img/icon-filter.svg
// module id = 1463
// module chunks = 0